module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Cooking/KnifeAndFork1-a0070536d73921f5516f2ee7569034c3.svg";